import React, { useContext, useEffect, useState } from "react";
import { Eye, Pencil, Send } from "lucide-react";
import { Table, Button, Modal } from "antd";
import { Modal as BootstrapModal } from "react-bootstrap";
import { EllipsisOutlined } from "@ant-design/icons";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { resetFormData, setStep, updateFormField } from "./Slices/formSlice";
import { AppContext } from "../context/AppContext";
import threeDots from "../assets/images/dots-vertical.svg";
import { ApiConfig } from "../Api/ApiConfig";
import { toastMsg } from "../component/toast";
import _ from "lodash";
// import "../../src/assets/style/Job.css";
// import "../../src/assets/style/Dummy.css";
import {
  fetchGET,
  simpleGetCallWithErrorResponse,
  PostCallWithErrorResponse,
} from "../Api/ApiServices";
import CustomButton from "../component/button";
import CustomSelect from "../constant/customselect";
import Jobinformation from "./jobinformation";
import { formatStringToDDMMYY, formatToDDMMYYYY, parseDate } from "../common";

export default function JobList(props) {
  const { setActiveMenu, adminData } = useContext(AppContext);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [jobCodesListArray, setJobCodeListArray] = useState([]);

  const [searchParams, setSearchParams] = useSearchParams()

  const behaviourTraits = {
    A: "Accuracy",
    B: "Cooperativeness",
    C: "Efficiency",
    D: "Enthusiasm",
    E: "Friendliness",
    F: "Independence",
    G: "Patience",
    H: "Persistence",
    I: "Self Confidence",
    J: "Self Motivation",
    K: "Sensitivity",
    L: "Thoughtfulness",
  };

  const [filteredInfo, setFilterInfo] = useState({});

  const handleChange = (pagination, filters, sorter) => {
    setFilterInfo(filters);
  };

  const [dataTransformIntoTable, setDataTransformIntoTable] = useState([]);
  const [showModal, setShowModal] = useState(null);
  const [showModals, setShowModals] = useState(false);

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  const [show, setShow] = useState(false);
  const [jobCode, setJobCode] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = (jobCode) => {
    setJobCode(jobCode);
    setShow(true);
  };
  function transformBehaviouralJD(behaviouralJD) {
    const { selected, non_selected, justifications } = behaviouralJD;

    const mapSelectedByUser = (code) => {
      const trait = behaviourTraits[code];
      const justification = justifications[code] || {};

      return {
        title: trait,
        behaviourCode: code,
        reasonForSelection: justification.reason,
        comparison: justification.compared_to,
        conditionForReconsideration: justification.deprioritize_conditions,
      };
    };

    const mapSelected = (code) => {
      const trait = behaviourTraits[code];
      const justification = justifications[code] || {};

      return {
        title: trait,
        behaviourCode: code,
        reasonForSelection: justification.reason,
        comparison: justification.compared_to,
        conditionForReconsideration: justification.deprioritize_conditions,
      };
    };

    const mapNonSelected = (code) => {
      const trait = behaviourTraits[code];
      const justification = justifications[code] || {};

      return {
        title: trait,
        behaviourCode: code,
        reasonForNonSelection: justification.reason,
        comparison: justification.compared_to,
        conditionForReconsideration: justification.deprioritize_conditions,
        selfConfidence: justification.self_confidence,
      };
    };

    return {
      selectedByUser: selected.map(mapSelectedByUser),
      selected: selected.map(mapSelected),
      nonSelected: non_selected.map(mapNonSelected),
    };
  }

  function transformResponsibilities(input) {

    if (!input[0]?.responsibilites) return input
    return input?.map(group => ({
      id: 0,
      groupTitle: group.responsibilites_group,
      responsibilities: group.responsibilites.map(responsibility => ({
        id: 0,
        responsibilityText: responsibility
      }))
    }));
  }

  const updateToUpubilshJd = (id) => {
    PostCallWithErrorResponse(ApiConfig.UPDATE_TO_UN_PUBLISH_JD + id)
  }

  const getDataForEdit = (code, codeName, isEdit = false) => {
    dispatch(resetFormData());

    if (isEdit) updateToUpubilshJd(code)

    simpleGetCallWithErrorResponse(ApiConfig.GET_JD_DETAILS + code).then(
      (res) => {
        if (res?.json?.succeded) {
          let details = res?.json?.response;
          dispatch(
            updateFormField({
              field: "comapnyDetailsId",
              value: details?.company?.id,
            })
          );
          dispatch(
            updateFormField({
              field: "companyId",
              value: details?.company?.id || "",
            })
          );
          dispatch(
            updateFormField({
              field: "companyName",
              value: details?.company?.companyName || "",
            })
          );
          dispatch(
            updateFormField({
              field: "industry",
              value: details?.company?.industry || "",
            })
          );
          dispatch(
            updateFormField({
              field: "website",
              value: details?.company?.companyWebsite || "",
            })
          );
          dispatch(
            updateFormField({
              field: "companyLogo",
              value: details?.company?.companyLogo || "",
            })
          );
          dispatch(
            updateFormField({
              field: "companyType",
              value: details?.company?.companyType || "",
            })
          );
          dispatch(
            updateFormField({
              field: "companySize",
              value: details?.company?.companySize || "",
            })
          );
          dispatch(
            updateFormField({ field: "companyDescription", value: details?.company?.aboutCompany || "" })
          );
          dispatch(
            updateFormField({
              field: "location",
              value: details?.company?.headQuarters || "",
            })
          );
          dispatch(
            updateFormField({
              field: "jobTitle",
              value: details?.jobInformation?.jobTitle || "",
            })
          );
          dispatch(
            updateFormField({
              field: "noOfPositions",
              value: details?.jobInformation?.noOfPositions || 1,
            })
          );
          dispatch(
            updateFormField({
              field: "department",
              value: details?.jobInformation?.department || "",
            })
          );
          dispatch(
            updateFormField({
              field: "experience",
              value: details?.jobInformation?.experienceReq || "",
            })
          );
          dispatch(
            updateFormField({
              field: "salary",
              value: details?.jobInformation?.salaryRange || "",
            })
          );
          dispatch(
            updateFormField({
              field: "minEducationQualification",
              value:
                details?.jobInformation?.minimumEducationalQualification || "",
            })
          );
          dispatch(
            updateFormField({
              field: "descriptionAboutJob",
              value: details?.jobInformation?.descriptionAboutJob || "",
            })
          );
          dispatch(
            updateFormField({
              field: "anyLanguageOtherThanEnglish",
              value: details?.jobInformation?.languages?.join(", ") || "",
            })
          );

          dispatch(
            updateFormField({
              field: "anyLanguageOtherThanEnglish",
              value: details?.jobInformation?.educationAreas?.join(", ") || "",
            })
          );
          dispatch(updateFormField({ field: 'travelRequirement', value: details?.jobInformation?.travel_requirements }))
          dispatch(
            updateFormField({
              field: "jobType",
              value: details?.jobInformation?.employmentType || "",
            })
          );
          dispatch(
            updateFormField({
              field: "workPlaceType",
              value: details?.jobInformation?.workplaceType || "",
            })
          );
          dispatch(
            updateFormField({
              field: "locationJobDetails",
              value: details?.jobInformation?.location || "",
            })
          );
          dispatch(
            updateFormField({
              field: "finalKeywordsForUser",
              value: details?.details?.keyWords || [],
            })
          );



          dispatch(
            updateFormField({
              field: "finalSelectedJobDescription",
              value: details?.details?.invitationToApply || "",
            })
          );


          dispatch(
            updateFormField({
              field: "generatedJobDescription",
              value: details?.details?.invitationToApply || "",
            })
          );

          dispatch(
            updateFormField({
              field: "finalSelectedResponsibilities",
              value: details?.responsibilityGroups || [],
            })
          );

          dispatch(
            updateFormField({
              field: "orgResponsibilties",
              value: transformResponsibilities(details?.responsibilityGroups) || [],
            })
          );



          let jobDetails = {
            job_title: details?.jobInformation?.jobTitle,
            job_experience: details?.jobInformation?.experienceReq,
            job_qualifications: details?.jobInformation?.minimumEducationalQualification,
            location: details?.jobInformation?.location,
            salary: details?.jobInformation?.salaryRange,
            language: details?.jobInformation?.languages?.join(''),
            job_type: details?.jobInformation?.employmentType,
            workplace_type: details?.jobInformation?.workplaceType,
            job_department: details?.jobInformation?.department,
            'travel_Requirement': details?.jobInformation?.travel_requirements
          }
          dispatch(
            updateFormField({
              field: "finalJobDetails",
              value: jobDetails || {},
            })
          );

          dispatch(
            updateFormField({
              field: "jobDetailsRespArray",
              value: jobDetails || {},
            })
          );



          dispatch(updateFormField({ field: "tempJobCode", value: codeName }));
          dispatch(
            updateFormField({
              field: "filteranalysis",
              value: details?.details?.filtered_analysis || "",
            })
          );
          dispatch(
            updateFormField({
              field: "generatedSkillsArray",
              value: details?.skillgroups || [],
            })
          );



          dispatch(
            updateFormField({
              field: "skillsRequiredForJob",
              value: details?.jobInformation?.skillsets || [],
            })
          );


          dispatch(
            updateFormField({
              field: "finalSkillsArray",
              value: details?.skillgroups || [],
            })
          );
          dispatch(updateFormField({ field: "jobDescriptionId", value: code }));

          if (isEdit) {
            // setShowModals(true)

            dispatch(
              updateFormField({
                field: "detailsId",
                valie: details?.details?.id,
              })
            );

            if (details?.step != 1) {
              sessionStorage.setItem(
                "prev_selected_keywords",
                JSON.stringify(details?.details?.keyWords || [])
              );
              // sessionStorage.setItem('prev_selected_answers', JSON.stringify(details?.details?.answers) || [])
              dispatch(
                updateFormField({
                  field: "allKeywords",
                  value: details?.details?.allKeyWords || [],
                })
              );
              dispatch(
                updateFormField({
                  field: "selectedKeywords",
                  value: details?.details?.keyWords,
                })
              );
              dispatch(
                updateFormField({
                  field: "behaviourQuestionsArray",
                  value: details?.details?.questions,
                })
              );
              dispatch(
                updateFormField({
                  field: "answers",
                  value: details?.details?.answers || [],
                })
              );

              dispatch(updateFormField({ field: "isEdit", value: true }));
            }

            dispatch(
              updateFormField({
                field: "step",
                value: !details?.jobInformation?.step
                  ? 1
                  : details?.jobInformation?.step === 2 ? 1 : details?.jobInformation?.step,
              })
            );
            setTimeout(() => {
              navigate("/jobDescription");
            }, [300]);
          } else {
            dispatch(
              updateFormField({
                field: "behaviorsDataApi",
                value: details?.details?.allBehaviours || {},
              })
            );
            dispatch(updateFormField({ field: "detailsId", valie: 0 }));
            dispatch(updateFormField({ field: "isEdit", value: false }));
            dispatch(updateFormField({ field: "isView", value: true }));
            dispatch(updateFormField({ field: "step", value: 3 }));
            navigate("/jobDescription");
          }
        }
      }
    );
  };

  const filterData = (data) => (formatter) =>
    data.map((item) => ({
      text: formatter(item),
      value: formatter(item),
    }));

  const columns = [
    {
      title: "Date Created",
      dataIndex: "dateTime",
      sorter: (a, b) => parseDate(a.dateTime) - parseDate(b.dateTime),
      filters: _.uniqWith(
        filterData(jobCodesListArray)((i) => formatStringToDDMMYY(i.dateTime)),
        _.isEqual
      ),
      render: (record) => formatStringToDDMMYY(record),
      filteredValue: filteredInfo.dateTime || null,
      filterSearch: true,
      onFilter: (value, record) =>
        formatStringToDDMMYY(record.dateTime) === value,

    },
    {
      title: "Company Name",
      dataIndex: "companyName",
      sorter: (a, b) => a.companyName?.trim().localeCompare(b.companyName?.trim()),
      filters: _.uniqWith(
        filterData(jobCodesListArray)((i) => i.companyName),
        _.isEqual
      ),
      filteredValue: filteredInfo.companyName || null,
      filterSearch: true,
      onFilter: (value, record) =>
        record.companyName.toString().toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: "Job Title",
      dataIndex: "jobTitle",
      sorter: (a, b) => a.jobTitle.localeCompare(b.jobTitle),
      filters: _.uniqWith(
        filterData(jobCodesListArray)((i) => i.jobTitle),
        _.isEqual
      ),
      filteredValue: filteredInfo.jobTitle || null,
      filterSearch: true,
      onFilter: (value, record) =>
        record.jobTitle.toString().toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: "Department",
      dataIndex: "department",
      sorter: (a, b) => a.department.localeCompare(b.department),
      filters: _.uniqWith(
        filterData(jobCodesListArray)((i) => i.department),
        _.isEqual
      ),
      filteredValue: filteredInfo.department || null,
      filterSearch: true,
      onFilter: (value, record) =>
        record?.department
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: "Location",
      dataIndex: "location",
      sorter: (a, b) => a?.location?.localeCompare(b.location),
      filters: _.uniqWith(
        filterData(jobCodesListArray)((i) => i.location),
        _.isEqual
      ),
      filteredValue: filteredInfo?.location || null,
      filterSearch: true,
      onFilter: (value, record) =>
        record?.location
          ?.toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    // {
    //   title: "Status",
    //   dataIndex: "jobDetails",
    //   sorter: (a, b) => a.jobDetails.localeCompare(b.jobDetails),
    //   filters: _.uniqWith(
    //     filterData(jobCodesListArray)((i) => i.jobDetails),
    //     _.isEqual
    //   ),
    //   filteredValue: filteredInfo?.jobDetails || null,
    //   onFilter: (value, record) =>
    //     record?.jobDetails?.toString().toLowerCase() == value.toLowerCase(),
    // },
    {
      title: "Quizes",
      dataIndex: "quizes",
      sorter: (a, b) => a.quizes.localeCompare(b.quizes),
      filters: _.uniqWith(
        filterData(jobCodesListArray)((i) => i.quizes),
        _.isEqual
      ),
      filteredValue: filteredInfo?.quizes || null,
      onFilter: (value, record) =>
        record?.quizes?.toString().toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: "Last Publish",
      dataIndex: "lastPublished",
      sorter: (a, b) => parseDate(a.lastPublished) - parseDate(b.lastPublished),
      filters: _.uniqWith(
        filterData(jobCodesListArray)((i) => formatStringToDDMMYY(i.lastPublished)),
        _.isEqual
      ),
      render: (record) => formatStringToDDMMYY(record),
      filteredValue: filteredInfo?.lastPublished || null,
      onFilter: (value, record) =>
        formatStringToDDMMYY(record.lastPublished) === value
      ,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) => (
        <div className="dropdown">
          <img
            src={threeDots}
            alt="Actions"
            type="button"
            id={`dropdownMenuButton-${record.key}`}
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            className="cursor-pointer"
          />
          <div
            className="dropdown-menu"
            aria-labelledby={`dropdownMenuButton-${record.key}`}
          >
            {/* <a
              className="dropdown-item"
              onClick={() => {
                console.log(record);
                handleActiveDeActiveCode(record?.isActive, record?.code);
              }}
            >
              {record?.isActive ? "InActive" : "Active"}
            </a> */}
            {/* <a
              className="dropdown-item"
              onClick={() => {

                getDataForEdit(record?.key)
              }}
            >
              Clone
            </a> */}
            {record?.jobDetails === "Complete" && (
              <a
                className="dropdown-item"
                style={{ fontSize: 'var(--font-size-base)', fontFamily: 'var(--ff-font-family-inter)' }}
                onClick={() => {
                  getDataForEdit(record?.id, record.code);
                }}
              >
                <Eye size={14} style={{ marginRight: 7 }} />
                View
              </a>
            )}

            <a
              className="dropdown-item"
              style={{ fontSize: 'var(--font-size-base)', fontFamily: 'var(--ff-font-family-inter)' }}
              onClick={() => {
                getDataForEdit(record?.id, record.code, true);
              }}
            >
              <Pencil size={14} style={{ marginRight: 7 }} />
              Edit
            </a>

            {/* <a
              className="dropdown-item"
              style={{ fontSize: 'var(--font-size-base)', fontFamily: 'var(--ff-font-family-inter)' }}
              onClick={() => handleShow(record?.code)}
            >
              Delete
            </a> */}
            {(adminData?.admin == "Admin" && record?.jobDetails === "Complete") && (
              <a
                className="dropdown-item"
                style={{ fontSize: 'var(--font-size-base)', fontFamily: 'var(--ff-font-family-inter)' }}
                onClick={() =>
                  navigate(
                    "/addEditGroup/" + record.code + `?detailsId=${record?.id}`
                  )
                }
              >
                <Send size={14} style={{ marginRight: 7 }} />
                Publish{" "}
              </a>
            )}
          </div>
        </div>
      ),
    },
  ];

  async function loadJobCodes() {
    const email = localStorage.getItem("email");

    const url =
      ApiConfig.GET_DRAFT_JOBCODE_LIST + `?email=${JSON.parse(email?.trim())}`;

    try {
      const response = await fetchGET(url);
      setJobCodeListArray(response.response);
      // Do something with the data
    } catch (error) {
      console.error("Error loading job codes:", error.message);
    }
  }
  let isBack = searchParams.get('isBack')

  useEffect(() => {



    if (isBack) {



      setShowModals(true)
    } else {

      dispatch(resetFormData());
    }

    loadJobCodes();
  }, []);

  const [loadingDeleteJobCode, setLoadingDeleteJobCode] = useState(false);
  const deleteJobCode = (id) => {
    console.log("id-----", id);
    setLoadingDeleteJobCode(true);
    PostCallWithErrorResponse(ApiConfig.DELETE_JOB_CODE + id)
      .then((res) => {
        if (res?.json?.succeded) {
          loadJobCodes();
          toastMsg("success", res?.json?.response?.statusMessage);
        } else {
          toastMsg("error", res?.json?.response?.statusMessage);
        }
      })
      .finally(() => {
        setLoadingDeleteJobCode(false);
        handleClose();
      });
  };

  return (
    <>
      <BootstrapModal show={show} onHide={handleClose}>
        <BootstrapModal.Header closeButton className="custom-close-btn">
          <h6 className="mb-0 mt-1">Delete Job</h6>
        </BootstrapModal.Header>
        <BootstrapModal.Body>
          <p>Are you sure want to delete this ? </p>
        </BootstrapModal.Body>
        <BootstrapModal.Footer>
          <CustomButton
            title={"Close"}
            handleClick={handleClose}
            buttonType="secondary"
          />

          <CustomButton
            title={"Delete"}
            handleClick={() => deleteJobCode(jobCode)}
            isLoading={loadingDeleteJobCode}
          />
        </BootstrapModal.Footer>
      </BootstrapModal>
      {!showModal && (
        <div>
          {/* <div className="jb-1 all-in"> */}
          {/* <main className="flex-1 p-10 bg-white"> */}
          <div className="d-flex justify-content-end mt-4">
            <div className="d-flex justify-content-end">
              {/* <div>
                <button
                  type="button"
                  // className="jp-but"
                  // style={{ height: "36px" }}
                  style={{ height: "36px" }}
                  className="ml-4 btnVldt text-base"
                  // onClick={navigateJobDescription}
                  onClick={() => {
                    dispatch(
                      updateFormField({ field: "isView", value: false })
                    );

                    dispatch(updateFormField({ field: "detailsId", valie: 0 }));
                    dispatch(
                      updateFormField({ field: "isEdit", value: false })
                    );
                    dispatch(resetFormData());
                    dispatch(updateFormField({ field: "step", value: "1" }));
                    setShowModals(true);
                  }}
                >
                  Create Job Description
                </button>
              </div> */}
            </div>
          </div>
          <div className="candListBox">
            <div className="candListHdr">
              <div className="canLisTxtStyl d-flex justify-content-between align-items-center w-100">
                <p>Job Description List</p>
                <div>
                  <button
                    type="button"
                    // className="jp-but"
                    // style={{ height: "36px" }}

                    className="btn  btn-primary"
                    // onClick={navigateJobDescription}
                    onClick={() => {
                      dispatch(
                        updateFormField({ field: "isView", value: false })
                      );

                      sessionStorage.clear()

                      setSearchParams({ isBack: false });

                      searchParams.delete('isBack')

                      dispatch(updateFormField({ field: "detailsId", valie: 0 }));
                      dispatch(
                        updateFormField({ field: "isEdit", value: false })
                      );
                      dispatch(resetFormData());
                      dispatch(updateFormField({ field: "step", value: "1" }));
                      setShowModals(true);
                    }}
                  >
                    Create Job Description
                  </button>
                </div>
              </div>

              <div className="grouplist-table">
                <Table
                  size="large"
                  columns={columns}
                  className="grouplisttable-alljobs"
                  // dataSource={filteredGrpListData.length>0? filteredGrpListData : groupListData}
                  dataSource={jobCodesListArray}
                  onChange={handleChange}
                  pagination={{ pageSize: 99999999 }}
                ></Table>
              </div>
            </div>
          </div>

          {showModals && (
            <Modal
              title="Job Description"
              open={showModals}
              onCancel={() => {

                searchParams.delete('isBack')
                setSearchParams(searchParams);
                setShowModals(false)
              }}
              footer={null}
              width={1000}
              centered
            >
              <hr />
              <Jobinformation isBack={isBack}
                setSearchParams={setSearchParams}
              />
            </Modal>
          )}
        </div>
      )}
    </>
  );
}
